function Reflection() {
  return (
    <section className="w-full mb-16 font-DM" id="Reflection">
      <h1 className="font-DM text-pinkie uppercase mb-6">Reflection</h1>
      <div className="mb-8">
        <p className="font-DM mb-6">
          Throughout our process of endless meetings, brainstorming sessions,
          and iterations, we learned how to pivot our ideas while continuing to
          build on the insights we had gathered through our research. It took
          time to identify the right problem space, and once we did, we
          developed our solution and produced our final deliverables within a
          tight timeframe. This experience taught me the value of staying open
          to change, trusting the research process, and collaborating closely
          when working through complex design challenges.
        </p>
        <p className="font-DM">
          I led the UX team in restructuring the overall architecture and flow
          of the new experience, then communicated these changes across the rest
          of the team. I maintained a holistic view of the prototype to ensure
          the experience remained cohesive, while also prototyping several
          flows.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-10">
        <img
          src="https://res.cloudinary.com/de9qkjreb/image/upload/v1789368021/kaya_process1_lbrcrr.png"
          alt="Process"
          className="w-full h-auto rounded self-end"
        ></img>
        <img
          src="https://res.cloudinary.com/de9qkjreb/image/upload/v1789368021/kaya_process2_f67o6g.png"
          alt="Process"
          className="w-full rounded self-end"
        ></img>
        <img
          src="https://res.cloudinary.com/de9qkjreb/image/upload/v1789368022/kaya_process3_le5q7w.png"
          alt="My team!"
          className="w-full rounded"
        ></img>
        <img
          src="https://res.cloudinary.com/de9qkjreb/image/upload/v1789368022/kaya_process4_jpw77u.png"
          alt="Process"
          className="w-full rounded"
        ></img>
      </div>
    </section>
  );
}

export default Reflection;
